<iframe
  width="100%"
  height="100%"
  src="{{data.iframeSrc | safe: 'resourceUrl'}}"
  frameborder="0"
></iframe
>;
